import React from "react";
import { useSpring, animated } from "react-spring";
import "./Page404.css";
import { useNavigate } from "react-router-dom";
import { siteUrl } from "../../clases/constans";
const Page404 = () => {
  const onclick = () => {
      window.location.href='/';

  };
  return (
    <div className="not-found">
      <div className="not-found__content">
        <h1 className="not-found__heading">404!</h1>
        <p className="not-found__message">
          اوه! صفحه‌ای که به دنبال آن هستید پیدا نشد.
        </p>
      </div>
      <div className="not-found__animation ">
        <div>
          {/* <div className="not-found__icon icon1">
            
          </div>
          <div className="not-found__icon icon2">
            
          </div>
        </div>
        <div>
          <div className="not-found__icon icon3 ">
           
          </div>
          <div className="not-found__icon icon4">
          
          </div> */}
        </div>
      </div>
      <button onClick={onclick} className="not-found__button">
        بازگشت
      </button>
    </div>
  );
};

export default Page404;
